import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["comment"]
  static values = {
    threshold: { type: Number, default: 0.8 },
    delay: { type: Number, default: 3000 }
  }

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      threshold: this.thresholdValue,
      delay: this.delayValue
    })

    this.commentTargets.forEach(comment => {
      this.observer.observe(comment)
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return

      const comment = entry.target
      const commentId = comment.dataset.id

      this.markCommentAsViewed(commentId)
      comment.classList.remove('-new')
    })
  }

  markCommentAsViewed(commentId) {
    const token = document.querySelector('meta[name="csrf-token"]').content

    fetch(`/comments/${commentId}/view`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify({})
    })
  }
}
